export const joinJsonPath = (prefix, path) => {
  if (prefix == null || path == null) return undefined;
  return `${prefix}${path}`;
};
